import { compose, createSelector } from '@reduxjs/toolkit';
import { convertAccumulators, excludeGiftAccumulators, filterAccumulatorTethering, filterNegativeAccumulators } from '@beef/elk-common';
import { TITLE_TETHERING, UnlimThreeStatus } from '@beef/elk-common/constants';
import { deleteReplenishmentButtonForAdditionalAccumulators, findClosestExpiringAdditionalAccumulator, getAccumulatorExpirationInfo, normalizeAdditionalAccumulatorRemainingSize } from "../../../../../utils/accumulators";
import { selectConvergentData, selectIsConvergent, selectIsFTTBUser, selectMobile, selectMobileConnectionPrice } from "../../store/selectors";
import { SpecialTariffType } from "../../constants/enums";
import { composeAccumulator } from "../../utils";

/* тарифы */
export var selectTariff = function selectTariff(state) {
  return state.tariff;
};
export var selectTariffPending = function selectTariffPending(state) {
  var _selectTariff;
  return (_selectTariff = selectTariff(state)) === null || _selectTariff === void 0 ? void 0 : _selectTariff.isPending;
};
export var selectTariffError = function selectTariffError(state) {
  var _selectTariff2;
  return (_selectTariff2 = selectTariff(state)) === null || _selectTariff2 === void 0 ? void 0 : _selectTariff2.isError;
};
export var selectTariffData = function selectTariffData(state) {
  var _selectTariff3;
  return (_selectTariff3 = selectTariff(state)) === null || _selectTariff3 === void 0 ? void 0 : _selectTariff3.data;
};
export var selectTariffLink = function selectTariffLink(state) {
  var _selectTariffData;
  return (_selectTariffData = selectTariffData(state)) === null || _selectTariffData === void 0 ? void 0 : _selectTariffData.url;
};
export var selectIsSvyazZ = function selectIsSvyazZ(state) {
  var _selectTariffData2;
  return ((_selectTariffData2 = selectTariffData(state)) === null || _selectTariffData2 === void 0 ? void 0 : _selectTariffData2.specialTariffType) === SpecialTariffType.SvyazZ;
};
export var selectIsProstoy = function selectIsProstoy(state) {
  var _selectTariffData3;
  return ((_selectTariffData3 = selectTariffData(state)) === null || _selectTariffData3 === void 0 ? void 0 : _selectTariffData3.specialTariffType) === SpecialTariffType.Prostoy;
};

/* аккумуляторы */
export var selectNewAccumulators = function selectNewAccumulators(state) {
  return state.accumulators;
};
export var selectAccumsPending = function selectAccumsPending(state) {
  var _selectNewAccumulator;
  return (_selectNewAccumulator = selectNewAccumulators(state)) === null || _selectNewAccumulator === void 0 ? void 0 : _selectNewAccumulator.isPending;
};
export var selectAccumulatorsError = function selectAccumulatorsError(state) {
  var _selectNewAccumulator2;
  return (_selectNewAccumulator2 = selectNewAccumulators(state)) === null || _selectNewAccumulator2 === void 0 ? void 0 : _selectNewAccumulator2.isError;
};
var selectAccumulatorsData = function selectAccumulatorsData(state) {
  var _selectNewAccumulator3;
  return (_selectNewAccumulator3 = selectNewAccumulators(state)) === null || _selectNewAccumulator3 === void 0 ? void 0 : _selectNewAccumulator3.data;
};
export var selectIsAccumSvyazZ = function selectIsAccumSvyazZ(state) {
  var _selectAccumulatorsDa;
  return !!((_selectAccumulatorsDa = selectAccumulatorsData(state)) !== null && _selectAccumulatorsDa !== void 0 && (_selectAccumulatorsDa = _selectAccumulatorsDa.accumulators) !== null && _selectAccumulatorsDa !== void 0 && _selectAccumulatorsDa.isForYoung);
};
export var selectIsAccumProstoy = function selectIsAccumProstoy(state) {
  var _selectAccumulatorsDa2;
  return !!((_selectAccumulatorsDa2 = selectAccumulatorsData(state)) !== null && _selectAccumulatorsDa2 !== void 0 && (_selectAccumulatorsDa2 = _selectAccumulatorsDa2.accumulators) !== null && _selectAccumulatorsDa2 !== void 0 && _selectAccumulatorsDa2.isTariffZv2);
};
export var selectIsManageAccumLink = function selectIsManageAccumLink(state) {
  var _selectAccumulatorsDa3;
  return ((_selectAccumulatorsDa3 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa3 === void 0 || (_selectAccumulatorsDa3 = _selectAccumulatorsDa3.accumulators) === null || _selectAccumulatorsDa3 === void 0 ? void 0 : _selectAccumulatorsDa3.tariffUrl) || '/customers/products/mobile/profile/';
};
export var selectAccumulatorsItems = function selectAccumulatorsItems(state) {
  var _selectAccumulatorsDa4;
  return (_selectAccumulatorsDa4 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa4 === void 0 || (_selectAccumulatorsDa4 = _selectAccumulatorsDa4.accumulators) === null || _selectAccumulatorsDa4 === void 0 ? void 0 : _selectAccumulatorsDa4.items;
};
export var selectHasAccTethering = createSelector([selectAccumulatorsItems], function (items) {
  return !!(items !== null && items !== void 0 && items.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.title) === TITLE_TETHERING;
  }));
});
export var selectMobileAccumulators = createSelector([selectAccumulatorsItems], function (accumulators) {
  return compose(filterAccumulatorTethering, convertAccumulators, deleteReplenishmentButtonForAdditionalAccumulators, normalizeAdditionalAccumulatorRemainingSize, filterNegativeAccumulators)(accumulators);
});
export var selectAccumService = function selectAccumService(state) {
  var _selectAccumulatorsDa5;
  return (_selectAccumulatorsDa5 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa5 === void 0 || (_selectAccumulatorsDa5 = _selectAccumulatorsDa5.accumulators) === null || _selectAccumulatorsDa5 === void 0 ? void 0 : _selectAccumulatorsDa5.services;
};
export var selectAccumMainCtn = function selectAccumMainCtn(state) {
  var _selectAccumulatorsDa6;
  return (_selectAccumulatorsDa6 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa6 === void 0 || (_selectAccumulatorsDa6 = _selectAccumulatorsDa6.accumulators) === null || _selectAccumulatorsDa6 === void 0 ? void 0 : _selectAccumulatorsDa6.mainCtn;
};
export var selectTetheringIsLow = function selectTetheringIsLow(state) {
  var _selectAccumulatorsDa7;
  return (_selectAccumulatorsDa7 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa7 === void 0 || (_selectAccumulatorsDa7 = _selectAccumulatorsDa7.accumulators) === null || _selectAccumulatorsDa7 === void 0 ? void 0 : _selectAccumulatorsDa7.tetheringIsLow;
};
export var selectClosestExpiringAdditionalAccumulatorInfo = createSelector([selectAccumulatorsItems], function (accumulators) {
  return compose(getAccumulatorExpirationInfo, findClosestExpiringAdditionalAccumulator, filterAccumulatorTethering, convertAccumulators, excludeGiftAccumulators)(accumulators);
});
var selectSharing = function selectSharing(state) {
  var _selectAccumulatorsDa8;
  return (_selectAccumulatorsDa8 = selectAccumulatorsData(state)) === null || _selectAccumulatorsDa8 === void 0 ? void 0 : _selectAccumulatorsDa8.sharing;
};
export var selectSharingList = function selectSharingList(state) {
  var _selectSharing;
  return (_selectSharing = selectSharing(state)) === null || _selectSharing === void 0 ? void 0 : _selectSharing.children;
};
export var selectParentInfo = function selectParentInfo(state) {
  var _selectSharing2;
  return (_selectSharing2 = selectSharing(state)) === null || _selectSharing2 === void 0 ? void 0 : _selectSharing2.parentInfo;
};
export var selectConnectionPrice = selectMobileConnectionPrice;
export var selectConnectionPriceData = function selectConnectionPriceData(state) {
  var _selectConnectionPric;
  return (_selectConnectionPric = selectConnectionPrice(state)) === null || _selectConnectionPric === void 0 ? void 0 : _selectConnectionPric.data;
};
export var selectTariffPrice = function selectTariffPrice(state) {
  var _selectConnectionPric2;
  return (_selectConnectionPric2 = selectConnectionPriceData(state)) === null || _selectConnectionPric2 === void 0 ? void 0 : _selectConnectionPric2.rcRate;
};
export var selectTariffPeriodDays = function selectTariffPeriodDays(state) {
  var _selectConnectionPric3;
  return (_selectConnectionPric3 = selectConnectionPriceData(state)) === null || _selectConnectionPric3 === void 0 ? void 0 : _selectConnectionPric3.rcRatePeriodDays;
};
export var selectTariffBillingDate = function selectTariffBillingDate(state) {
  var _selectConnectionPric4;
  return (_selectConnectionPric4 = selectConnectionPriceData(state)) === null || _selectConnectionPric4 === void 0 ? void 0 : _selectConnectionPric4.billingDate;
};
export var selectMobileConnectionBlockPricePending = function selectMobileConnectionBlockPricePending(state) {
  var _selectMobile;
  return (_selectMobile = selectMobile(state)) === null || _selectMobile === void 0 || (_selectMobile = _selectMobile.price) === null || _selectMobile === void 0 ? void 0 : _selectMobile.pending;
};
export var selectConnectionBlockError = function selectConnectionBlockError(state) {
  var _selectMobile2;
  return (_selectMobile2 = selectMobile(state)) === null || _selectMobile2 === void 0 || (_selectMobile2 = _selectMobile2.price) === null || _selectMobile2 === void 0 ? void 0 : _selectMobile2.error;
};
export var selectTariffTitle = createSelector([selectIsFTTBUser, selectIsConvergent], function (isFttb, isConvergent) {
  var internet = 'домашний интернет';
  if (isFttb) {
    return internet;
  }
  return "\u043C\u043E\u0431\u0438\u043B\u044C\u043D\u0430\u044F \u0441\u0432\u044F\u0437\u044C".concat(isConvergent ? ' + домашний интернет' : '');
});
export var selectIsTariffBlockPending = createSelector([selectTariffPending, selectMobileConnectionBlockPricePending], function (isTariffPending, isPricePending) {
  return isTariffPending || isPricePending;
});
export var selectTariffBlockError = createSelector([selectTariffError, selectConnectionBlockError], function (isTariffError, isPriceError) {
  return isTariffError || isPriceError;
});
export var selectShowSettingButton = createSelector([selectAccumulatorsData, selectMobileAccumulators, selectAccumsPending, selectAccumulatorsError], function (data, accums, isPending, isError) {
  return !!data && !(accums !== null && accums !== void 0 && accums.length) && !isPending && !isError;
});

// есть ли аккумулятор тетеринг
export var selectHasTetheringUnlimit = createSelector([selectAccumService, selectTetheringIsLow, selectHasAccTethering], function (hasService, tetheringIsLow, hasAccTethering) {
  var _hasService$unlimited;
  return !!(hasService !== null && hasService !== void 0 && hasService.tethering) || !!(hasService !== null && hasService !== void 0 && hasService.unlimited24) || (hasService === null || hasService === void 0 || (_hasService$unlimited = hasService.unlimited3) === null || _hasService$unlimited === void 0 ? void 0 : _hasService$unlimited.status) === UnlimThreeStatus.ACTIVE || tetheringIsLow || hasAccTethering;
});

/* конвергент */
var selectInternet = function selectInternet(state) {
  var _selectConvergentData;
  return ((_selectConvergentData = selectConvergentData(state)) === null || _selectConvergentData === void 0 ? void 0 : _selectConvergentData.internet) || {};
};
export var selectInternetIcon = function selectInternetIcon(state) {
  var _selectInternet;
  return (_selectInternet = selectInternet(state)) === null || _selectInternet === void 0 ? void 0 : _selectInternet.icon;
};
var selectTV = function selectTV(state) {
  var _selectConvergentData2;
  return ((_selectConvergentData2 = selectConvergentData(state)) === null || _selectConvergentData2 === void 0 ? void 0 : _selectConvergentData2.tv) || {};
};
export var selectTVIcon = function selectTVIcon(state) {
  var _selectTV;
  return (_selectTV = selectTV(state)) === null || _selectTV === void 0 ? void 0 : _selectTV.icon;
};
export var selectConvergentAccumulators = createSelector([selectInternet, selectInternetIcon, selectTV, selectTVIcon], function (internet, internetImage, tv, tvImage) {
  return [composeAccumulator({
    iconSrc: internetImage,
    value: internet.value,
    unit: internet.unit
  }), composeAccumulator({
    iconSrc: tvImage,
    value: tv.value,
    unit: "".concat(tv.tabName, "-").concat(tv.unit)
  })].filter(function (item) {
    return !!item;
  });
});
export var selectConnectUrl = function selectConnectUrl(state) {
  var _selectConvergentData3;
  return (_selectConvergentData3 = selectConvergentData(state)) === null || _selectConvergentData3 === void 0 ? void 0 : _selectConvergentData3.convergentConnectUrl;
};
var selectTechnicalInfo = function selectTechnicalInfo(state) {
  var _selectConvergentData4;
  return ((_selectConvergentData4 = selectConvergentData(state)) === null || _selectConvergentData4 === void 0 ? void 0 : _selectConvergentData4.technicalInfo) || {};
};
export var selectAddress = function selectAddress(state) {
  var _selectTechnicalInfo;
  return (_selectTechnicalInfo = selectTechnicalInfo(state)) === null || _selectTechnicalInfo === void 0 ? void 0 : _selectTechnicalInfo.address;
};